export enum YmGoalCatalog {
  FilterChanged = 'catalogFilterChanged',
  CategoryButtonClick = 'catalogCategoryButtonClick',
  ItemListAddToCart = 'catalogItemListAddToCart',
}
